import t, { useState as P, useEffect as A } from "react";
import { Text as u } from "../Text/Text.js";
import { Divider as I } from "../Divider/Divider.js";
import { ChevronUp as $, ChevronDown as j } from "@olxbr/ds-icons";
import { accordionDefaultProps as i } from "./props.js";
import { cls as d } from "../../helpers/cls.js";
var R = Object.defineProperty,
  a = Object.getOwnPropertySymbols,
  h = Object.prototype.hasOwnProperty,
  E = Object.prototype.propertyIsEnumerable,
  w = (o, r, e) => r in o ? R(o, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : o[r] = e,
  k = (o, r) => {
    for (var e in r || (r = {})) h.call(r, e) && w(o, e, r[e]);
    if (a) for (var e of a(r)) E.call(r, e) && w(o, e, r[e]);
    return o;
  },
  L = (o, r) => {
    var e = {};
    for (var n in o) h.call(o, n) && r.indexOf(n) < 0 && (e[n] = o[n]);
    if (o != null && a) for (var n of a(o)) r.indexOf(n) < 0 && E.call(o, n) && (e[n] = o[n]);
    return e;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const V = "--color-neutral-70",
  x = o => {
    const r = o,
      {
        id: e,
        icon: n,
        header: D,
        description: s,
        children: y,
        chevronPosition: m = i.chevronPosition,
        showDescription: N = i.showDescription,
        open: p = i.open,
        disabled: l = i.disabled,
        withBorder: _ = i.withBorder,
        bgColor: O = V,
        hideDivider: S = !1,
        className: g,
        onClick: v
      } = r,
      B = L(r, ["id", "icon", "header", "description", "children", "chevronPosition", "showDescription", "open", "disabled", "withBorder", "bgColor", "hideDivider", "className", "onClick"]),
      [c, b] = P(!1);
    A(() => {
      b(l ? !1 : p);
    }, [p, l]);
    const f = C => t.createElement("span", {
      className: "olx-accordion__icon"
    }, C ? t.createElement($, {
      "data-testid": "chevron-up-icon"
    }) : t.createElement(j, {
      "data-testid": "chevron-down-icon"
    }));
    return t.createElement("div", k({
      className: d("olx-accordion", _ && "olx-accordion--bordered", g),
      style: {
        "--bg-color": "var(".concat(O, ")")
      },
      "data-ds-component": "DS-Accordion"
    }, B), t.createElement("button", {
      className: d("olx-accordion__button", _ && "olx-accordion__button--bordered"),
      "data-ds-component": "DS-Accordion-Button",
      onClick: () => {
        v == null || v(!c), b(!c);
      },
      tabIndex: 0,
      "aria-expanded": c,
      "aria-controls": "contentSection".concat(e),
      id: "accordion".concat(e),
      disabled: l
    }, m === "left" ? f(c) : n && t.createElement("span", {
      className: "olx-accordion__icon"
    }, n), t.createElement("div", {
      className: "olx-accordion__button-text"
    }, t.createElement(u.BodyLarge, {
      weight: "semibold"
    }, D), N && s && t.createElement(u.BodyMedium, {
      marginTop: "--spacing-1"
    }, s)), m === "right" && f(c)), t.createElement("div", {
      className: d("olx-accordion__content-wrapper", c && "olx-accordion__content-wrapper--show"),
      role: "region",
      id: "contentSection".concat(e),
      "aria-labelledby": "accordion".concat(e)
    }, t.createElement("div", null, !S && t.createElement(I, null), t.createElement("div", {
      className: "olx-accordion__content"
    }, y))));
  };
x.displayName = "Accordion";
export { x as Accordion };